import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import AuthService from '../../services/api/userInfoService';
import { setNotificationCount, setNotificationLoad, settNotifications, setUserProfile } from '../Global/globalSlice';
// import { unauthorizedError } from '../../utils/helpers';
import { message } from 'antd';
import { API_ROUTES } from '../../utils/constants';
import _axios from '../../services/api';


const userData = new AuthService();

export const get_all_Subscriptions_jobseeker = createAsyncThunk(
    "userData/get_all_Subscriptions_jobseeker",
    async ({ navigate }, { dispatch }) => {
        try {
            const response = await userData.Get_all_subscriptions()
            dispatch(setAllSubscription(response.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                error?.response?.data?.message && message.error(error?.response?.data?.message)
            // }
        }
    }
);

export const get_latest_Subscriptions_jobseeker = createAsyncThunk(
    "userData/get_latest_Subscriptions_jobseeker",
    async ({ navigate }, { dispatch }) => {
        try {
            const response = await userData.Get_latest_subscriptions()
            dispatch(setLatestSubscriptions(response.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                error?.response?.data?.message && message.error(error?.response?.data?.message)
            // }
        }
    }
);

export const get_reffeed_by = createAsyncThunk(
    "userData/get_reffeed_by",
    async ({ navigate }, { dispatch }) => {
        try {
            const response = await userData.Get_ReferrsBy_Jobs()
            dispatch(setRefferedBydata(response.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                error?.response?.data?.message && message.error(error?.response?.data?.message)
            // }
        }
    }
);

export const get_reffeed_To = createAsyncThunk(
    "userData/get_reffeed_To",
    async ({ navigate }, { dispatch }) => {
        try {
            const response = await userData.Get_ReffersTo_Jobs()
            dispatch(setRefferedTodata(response.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                error?.response?.data?.message && message.error(error?.response?.data?.message)
            // }
        }
    }
);

export const get_Jobseeker_notifications = createAsyncThunk(
    "userData/get_Jobseeker_notifications",
    async ({ navigate }, { dispatch }) => {
        dispatch(setNotificationLoad(true))
        try {
            const { data } = await _axios.get(API_ROUTES.JOBSEEKER.NOTIFICATIONS);
            dispatch(settNotifications(data?.data))
            dispatch(setNotificationCount(data?.notification))
            dispatch(setNotificationLoad(false))
        } catch (error) {
            // if (error?.response && [401, 403, 419, 440].includes(error.response.status)) {
            //     dispatch(setUserProfile({}));
            //     unauthorizedError(navigate);
            // }
        } finally {
            dispatch(setNotificationLoad(false))
        }
    }
);


const initialState = {
    allSubscriptions: [],
    latestSubscriptions: [],
    selectedCV: {},
    reffredTodata: [],
    reffredBydata: [],
    ownSkillsData: [],
    isMoreJob: false,
    selectedjobData: {},
    selectedMenu: '',
    jobsCount: 0,
    isAllJobs: false,
    isFilledSearch: false,
    jobseekerId: ''
};

const userDataSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {
        setAllSubscription: (state, action) => {
            state.allSubscriptions = action.payload
        },
        setLatestSubscriptions: (state, action) => {
            state.latestSubscriptions = action.payload
        },
        setSelectedCV: (state, action) => {
            state.selectedCV = action.payload
        },
        setRefferedBydata: (state, action) => {
            state.reffredBydata = action.payload
        },
        setRefferedTodata: (state, action) => {
            state.reffredTodata = action.payload
        },
        setOwnSkillsData: (state, action) => {
            state.ownSkillsData = action.payload
        },
        setIsMoreJob: (state, action) => {
            state.isMoreJob = action.payload
        },
        setSelectedJobData: (state, action) => {
            state.selectedjobData = action.payload
        },
        setSelectedMenu: (state, action) => {
            state.selectedMenu = action.payload
        },
        setJobsCount: (state, action) => {
            state.jobsCount = action.payload
        },
        setIsAllJobs: (state, action) => {
            state.isAllJobs = action.payload
        },
        setIsFilledGlobalSearch: (state, action) => {
            state.isFilledSearch = action.payload
        },
        setJobseekerId: (state, action) => {
            state.jobseekerId = action.payload
        }
    }
});

export const
    { setAllSubscription, setLatestSubscriptions, setSelectedCV, setRefferedBydata,
        setRefferedTodata, setOwnSkillsData, setIsMoreJob, setSelectedJobData,
        setSelectedMenu, setJobsCount, setIsAllJobs, setIsFilledGlobalSearch, setJobseekerId } = userDataSlice.actions;
export default userDataSlice.reducer;
